
// ROUTES
require('modules/tutorial/routes/tutorial');

// CONTROLLERS
require('modules/tutorial/controllers/tutorial');

// SERVICES
require('modules/tutorial/services/tutorial');
require('modules/tutorial/services/list');


angular.module('unica_tutorial', [

	// ROUTES
	'unica_tutorial.tutorial_routes',

	// CONTROLLERS
	'unica_tutorial.tutorial_controllers',

	// SERVICES
	'unica_tutorial.tutorial_services'

]);